import { useParams } from 'react-router';
import { ViewModelList } from './ViewModelList';
import { useTagAssignedViewModels } from '../ViewModelPage/hooks/useTagAssignedViewModels';
import { ViewModelTagEditor } from './ViewModelTagEditor';
import { TOP_NAVIGATION_HEIGHT, TopNavigation } from '@framework/ui/elements/TopNavigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { NotFound } from '@framework/ui/pages/NotFound';
import { UserPagePathBuilder } from '../UserPagePathBuilder';
import { ViewModelTagOperation } from '@view-model/domain/view-model/ViewModelTagOperation';
import { Loading } from '@framework/ui/atoms/Loading';
import { useTranslation } from 'react-i18next';

export const TagAssignedViewModelsPage: React.FC<unknown> = () => {
  const { t } = useTranslation();
  const { groupId, viewModelTagId } = useParams<{ groupId: string; viewModelTagId: string }>();
  const { viewModelAndWorkspaces, loading } = useTagAssignedViewModels(groupId ?? '', viewModelTagId ?? '');

  const [tagName, setTagName] = useState('');
  const [tagFound, setTagFound] = useState<boolean | null>(null);

  useEffect(() => {
    async function init() {
      if (!groupId || !viewModelTagId) return;
      const tag = await ViewModelTagOperation.find(groupId, viewModelTagId);
      if (tag === null) {
        setTagFound(false);
        return;
      }
      setTagFound(true);
      setTagName(tag.name);
    }

    init();
  }, [groupId, viewModelTagId]);

  if (!groupId || !viewModelTagId) {
    return <NotFound message={t('home.tag.invalidParams')} />;
  }

  if (tagFound === false) {
    return (
      <NotFound
        message={t('home.tag.notFound')}
        linkTo={UserPagePathBuilder.groupPage(groupId)}
        linkToMessage={t('common.label.backToGroup')}
      />
    );
  }

  return (
    <div className="block h-screen w-full overflow-y-auto">
      <TopNavigation />
      <div className="overflow-y-auto px-10 pb-32 pt-3" style={{ height: `calc(100vh - ${TOP_NAVIGATION_HEIGHT}px)` }}>
        <div className="my-2 flex w-full items-center justify-between border-b-2 p-1">
          <div className="flex flex-row items-center justify-start" style={{ width: 'calc(100% - 8rem)' }}>
            <div className="flex items-center justify-start truncate text-3xl font-bold">
              <FontAwesomeIcon icon={faTags} />
              <span className="pl-3">{tagName}</span>
            </div>
          </div>
          <div className="flex items-end justify-end">
            <ViewModelTagEditor
              groupId={groupId}
              viewModelTagId={viewModelTagId}
              tagName={tagName}
              setTagName={setTagName}
            />
          </div>
        </div>

        <div className="flex w-full flex-row justify-between py-4">
          <div className="flex w-full flex-col">
            <div className="mb-5 px-3">
              {loading ? <Loading /> : <ViewModelList viewModelAndWorkspaces={viewModelAndWorkspaces} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
